@use "~components/Button/tokens.scss" as button-tokens;

.contentLoader {
  width: 100%;
  height: button-tokens.$button-standard-height;
}
